import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledAddFollowUpButton = styled(Button)<{$position?: 'start' | 'end'}>(
    ({$position = 'start'}) => css`
        align-self: ${$position};
    `
)
